module.exports = __webpack_public_path__ + "img/category-favorite.479cf424.png";